import { isRejectedWithValue } from '@reduxjs/toolkit';
import { Middleware, MiddlewareAPI } from 'redux';
import { toastError } from '../../../utils/api.utils';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => next => action => {
  if (isRejectedWithValue(action)) {
    const err: any = action.error || {};
    const message = (err.data && (err.data.message || err.data.error)) || err.message || 'Произошла ошибка запроса';
    // завернём в форму, понятную toastError/errorCatch
    const wrapped = { response: { data: { error: message } } } as any;
    try { toastError(wrapped); } catch { /* toastError может бросать строку - игнорируем */ }
  }

  return next(action);
};
